(() => {
  if (customElements.get('k18-video-hero')) return;

  class K18VideoHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.k18-videohero__toggle');
      if (!this.video || !this.button) return;

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlayback = this.dataset.autoplay === 'true' && !this.motion.matches && !navigator.connection?.saveData;
      this.inView = true;
      this.manuallyPaused = false;
      this.button.hidden = false;

      const updateButton = () => {
        const playing = !this.video.paused;
        this.button.setAttribute('aria-label', playing ? 'Sæt video på pause' : 'Afspil video');
        this.button.setAttribute('aria-pressed', String(playing));
      };

      this.syncPlayback = () => {
        if (this.wantsPlayback && this.inView && !document.hidden) {
          const result = this.video.play();
          result?.catch(() => updateButton());
        } else {
          this.video.pause();
        }
      };

      this.video.addEventListener('play', updateButton, { signal });
      this.video.addEventListener('pause', updateButton, { signal });
      this.video.addEventListener('error', () => {
        this.video.hidden = true;
        this.video.style.display = 'none';
        this.button.hidden = true;
      }, { signal });
      this.button.addEventListener('click', () => {
        this.wantsPlayback = this.video.paused;
        this.manuallyPaused = !this.wantsPlayback;
        this.syncPlayback();
      }, { signal });
      document.addEventListener('visibilitychange', this.syncPlayback, { signal });
      this.motion.addEventListener('change', () => {
        this.wantsPlayback = !this.motion.matches && this.dataset.autoplay === 'true' && !this.manuallyPaused && !navigator.connection?.saveData;
        this.syncPlayback();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }

      updateButton();
      this.syncPlayback();
    }

    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('k18-video-hero', K18VideoHero);
})();
